module.exports = __webpack_public_path__ + "img/skills-wind-dru-1.d320b3cc.png";